import { render, staticRenderFns } from "./privatechat.vue?vue&type=template&id=3e965920&"
import script from "./privatechat.vue?vue&type=script&lang=js&"
export * from "./privatechat.vue?vue&type=script&lang=js&"
import style0 from "./privatechat.vue?vue&type=style&index=0&id=3e965920&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports